import React, { useEffect, useState } from "react";
import { Sparkles, ArrowRight, X } from "lucide-react";
import { PROMO } from "../data/promo";

export default function PromoBar() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("acdt_promo_dismissed");
    if (dismissed === "1") setVisible(false);
  }, []);

  const dismiss = () => {
    setVisible(false);
    try {
      sessionStorage.setItem("acdt_promo_dismissed", "1");
    } catch (e) {
      // ignore
    }
  };

  if (!visible) return null;

  return (
    <div className="relative z-[60] bg-gradient-to-r from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-11 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <span className="hidden sm:inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#f59e0b] text-[#0a1f55] text-[10.5px] font-extrabold uppercase tracking-wider">
            <Sparkles className="h-3 w-3" />
            {PROMO.active ? PROMO.badge : "Novità"}
          </span>
          <p className="text-[12.5px] md:text-[13.5px] font-medium truncate" data-testid="promo-bar-text">
            Corso A.C.D.T. per la qualificazione professionale «Consulente Digitale» —
            {PROMO.active ? (
              <>
                <span className="line-through text-white/60 ml-1">€ {PROMO.prezzoListinoCorso}</span>
                <span className="font-extrabold text-[#fbbf24] ml-1">€ {PROMO.prezzoPromoCorso}</span>
                <span className="hidden md:inline ml-1.5 text-[#fbbf24]/80">· {PROMO.labelOfferta}</span>
              </>
            ) : (
              <span className="font-bold text-[#fbbf24] ml-1">da € 99</span>
            )}
          </p>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <a
            href="/#pacchetti"
            className="inline-flex items-center gap-1 text-[12px] font-bold text-white hover:text-[#fbbf24] transition-colors"
          >
            Scopri i pacchetti
            <ArrowRight className="h-3.5 w-3.5" />
          </a>
          <button
            onClick={dismiss}
            aria-label="chiudi"
            className="h-7 w-7 rounded-md hover:bg-white/10 flex items-center justify-center text-white/80 hover:text-white transition-colors"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    </div>
  );
}
